import {
  MAINTENANCE_ACTIONS_LIST,
  MAINTENANCE_MENU_GROUPS_LIST,
  MAINTENANCE_MENU_OPTIONS_LIST,
  MAINTENANCE_MENUS_LIST,
  MAINTENANCE_PAGES_LIST,
  USR_SPECIAL_ACCESS_USER_LIST,
  USR_DUALPAYMENTS_COMPANY_LIST,
  USR_DUALPAYMENTS_COMPANY_DETAIL,
} from "./pagesRoutes";

export const SPECIAL_ACCESS_ROUTES: readonly string[] = [
  MAINTENANCE_MENU_GROUPS_LIST,
  MAINTENANCE_MENUS_LIST,
  MAINTENANCE_MENU_OPTIONS_LIST,
  MAINTENANCE_PAGES_LIST,
  MAINTENANCE_ACTIONS_LIST,
  USR_SPECIAL_ACCESS_USER_LIST,
  USR_DUALPAYMENTS_COMPANY_LIST,
  USR_DUALPAYMENTS_COMPANY_DETAIL,
];

export const SPECIAL_ACCESS_FEATURES = {
  CREATE_COMPANY: "CREATE_COMPANY",
} as const;
